
import { SVGPATH } from '@/utils/const/svgPath';

export default {
  name: 'IconSvg',
  props: {
    // icon file name
    iconName: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
  },
  data(){
    return {
      SVGPATH: SVGPATH,
    }
  },
  computed: {
    innerIconName() {
      const res = require(`~/assets/svg/${this.SVGPATH[this.iconName]}`)
      return `${res.default}#icon-${this.iconName}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
  },
}
